import * as React from "react";
import Grid from '@mui/material/Grid2';

interface ISelectedAffiliate {
  president?: string;
  local?: number;
  localNumber?: string;
  delegateEntitlement?: number;
  secretary?: string;
  delegateCount?: number;
  treasurer?: string;
  alternateCount?: number;
  totalVotes?: number;
  [key: string]: unknown;
}

interface IAffiliateRecordInfoProps {
  selectedAffiliate: ISelectedAffiliate;
}

const AffiliateRecordInfo: React.FunctionComponent<IAffiliateRecordInfoProps> = props => {
  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }} className="pt-3">
        <span className="local-number">
          Local Number:{" "}
          {props.selectedAffiliate.localNumber
            ? props.selectedAffiliate.localNumber
            : "N/A"}
        </span>
      </Grid>
      <Grid container size={{ xs: 12 }} className="pt-3 affiliate-detail-label">
        <Grid size={{ xs: 12, md: 3 }}>
          <span className={"affiliate-detail-label"}>President: </span>
          <span className={"affiliate-detail-value"}>
            {props.selectedAffiliate.president
              ? props.selectedAffiliate.president
              : "N/A"}
          </span>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} offset={{ md: 2 }}>
          <div>
            <span className={"affiliate-detail-label"}>
              Delegate Strength:{" "}
            </span>
            <span className={"affiliate-detail-value"}>
              {props.selectedAffiliate.delegateEntitlement
                ? props.selectedAffiliate.delegateEntitlement
                : "N/A"}
            </span>
          </div>
          <div>
            <span className={"affiliate-detail-label"}>Number of Delegates: </span>
            <span className={"affiliate-detail-value"}>
              {props.selectedAffiliate.delegateCount
                ? props.selectedAffiliate.delegateCount
                : "N/A"}
            </span>
          </div>
          <div>
            <span className={"affiliate-detail-label"}>Number of Alternates: </span>
            <span className={"affiliate-detail-value"}>
              {props.selectedAffiliate.alternateCount
                ? props.selectedAffiliate.alternateCount
                : "N/A"}
            </span>
          </div>
        </Grid>
        <Grid size={{ xs: 12 }} className={"pt-4"}>
          <span className={"affiliate-detail-label total-votes-label"}>
            Total Votes:{" "}
          </span>
          <span className={"affiliate-detail-value"}>
            {props.selectedAffiliate.totalVotes
              ? props.selectedAffiliate.totalVotes
              : "N/A"}
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AffiliateRecordInfo;
